import PageHeading from "../../../components/desktop/PageHeading";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../../store/authStore";
import back from "../../../assets/back.png";

import "./Profilemaster.css";

export default function Profile() {
  const navigate = useNavigate();

  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  if (!user) {
    return (
      <div className="employee-profile-page">
        <div className="employee-profile-content">
          <p>User information not available.</p>
        </div>
      </div>
    );
  }

  const employeeName =
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

  return (
    <div className="desktop-profile-page">
      <div className="desktop-profile-topbar">
        <button
          className="desktop-profile-back"
          onClick={() => navigate(-1)}
        >
          <img
            src={back}
            alt="Back"
            className="desktop-profile-back-icon"
          />
        </button>

        <PageHeading>Profile</PageHeading>
      </div>

      <div className="desktop-profile-wrapper">
        {/* Header */}
        <div className="desktop-profile-header">
          <div className="desktop-profile-avatar">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              alt="Profile"
            />
          </div>

          <div className="desktop-profile-info">
            <h1>{employeeName || "Employee"}</h1>

            <p>{user?.employee_code || "-"}</p>

            <span>{user?.designation_name || "-"}</span>
          </div>

          <button className="desktop-profile-logout" onClick={handleLogout}>
            Log Out
          </button>
        </div>

        <div className="desktop-profile-line"></div>

      {/* Details Card */}
<div className="desktop-profile-card">
  <table className="desktop-profile-table">
    <tbody>
      <tr>
        <td>Company ID</td>
        <td>{user?.company_id || "-"}</td>
      </tr>

      <tr>
        <td>Employee Code</td>
        <td>{user?.employee_code || "-"}</td>
      </tr>

      <tr>
        <td>Email</td>
        <td>{user?.email_id || "-"}</td>
      </tr>

      <tr>
        <td>Mobile</td>
        <td>
          {user?.country_code
            ? `${user.country_code} ${user.mobile_no}`
            : user?.mobile_no || "-"}
        </td>
      </tr>

      <tr>
        <td>Location</td>
        <td>{user?.location_name || "-"}</td>
      </tr>

      <tr>
        <td>Department</td>
        <td>{user?.department_name || "-"}</td>
      </tr>

      <tr>
        <td>Designation</td>
        <td>{user?.designation_name || "-"}</td>
      </tr>

      <tr>
        <td>Desktop Access</td>
        <td>{user?.desktop_access ? "Yes" : "No"}</td>
      </tr>

      <tr>
        <td>Role</td>
        <td>{user?.role === 1 ? "Admin" : "User"}</td>
      </tr>
    </tbody>
  </table>
</div>

       
      </div>
    </div>
  );
}
